import { css } from '@linaria/core';
import { Anchor, Breadcrumbs } from '@mantine/core';
import ShareButton from 'components/ShareButton';
import { useRouter } from 'next/router';
import { breakpoints } from 'styles/utils';
import { useBreakpoint } from 'utils/responsive';
type Breadcrumb = {
  title?: string;
  href?: string;
};
export function BreadcrumbsLink() {
  const breadcrumbs = useNavbarBreadcrumbs();
  const isMobileViewport = useBreakpoint(breakpoints.down('tab'));
  if (isMobileViewport) {
    return null;
  }
  return <div className={breadcrumbsStyles.wrapper}>
      <Breadcrumbs className={breadcrumbsStyles.breadcrumbs}>
        {breadcrumbs.map(breadcrumb => <Anchor href={breadcrumb.href} key={breadcrumb.title} className={breadcrumbsStyles.breadcrumb}>
            {breadcrumb.title}
          </Anchor>)}
      </Breadcrumbs>
      {!!breadcrumbs.length && <ShareButton copyUrl={window?.location?.href} copyTooltipText="Copy URL" copySuccessMessage="URL copied to clipboard" />}
    </div>;
}
export function useNavbarBreadcrumbs(): Breadcrumb[] {
  const router = useRouter();
  let breadcrumbs: Breadcrumb[] = [];

  // Use asPath to get the current path, including dynamic segments
  const path = router.asPath.split('?')[0].split('#')[0];
  const segments = path.split('/').filter(Boolean);

  // Build up the href for each segment
  let accumulatedPath = '';
  breadcrumbs = segments.map(segment => {
    // Build up the href for each segment
    accumulatedPath += `/${segment}`;
    // Make any necessary changes to the segment for the title
    if (segment === 'explore') {
      segment = 'community';
    }
    return {
      title: segment,
      href: accumulatedPath
    };
  });
  return breadcrumbs;
}
const breadcrumbsStyles = {
  wrapper: "omponents__Navbar__components__BreadcrumbsLink__BreadcrumbsLink_tsx-wrapper-wy1h8p8",
  breadcrumbs: "omponents__Navbar__components__BreadcrumbsLink__BreadcrumbsLink_tsx-breadcrumbs-br2zmw5",
  breadcrumb: "omponents__Navbar__components__BreadcrumbsLink__BreadcrumbsLink_tsx-breadcrumb-b19a8am",
  copyButton: "omponents__Navbar__components__BreadcrumbsLink__BreadcrumbsLink_tsx-copyButton-c113oqum"
};

require("./BreadcrumbsLink.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./BreadcrumbsLink.tsx");